import { render, staticRenderFns } from "./ClaioAdapter.vue?vue&type=template&id=80eb6828&scoped=true&"
import script from "./ClaioAdapter.vue?vue&type=script&lang=ts&"
export * from "./ClaioAdapter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80eb6828",
  null
  
)

export default component.exports